(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bubima-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const dialog = document.querySelector('.bh-contact-dialog');
    if (event.target.closest('[data-bh-contact-open]') && dialog) { dialog.showModal(); document.querySelector('.bh-contact').open = false; }
    if (event.target.closest('[data-bh-contact-close]') && dialog) dialog.close();
    document.querySelectorAll('.bh-departments[open],.bh-contact[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.bh-departments[open],.bh-contact[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  const contactResult = document.querySelector('[data-bh-contact-result]');
  if (contactResult) contactResult.closest('dialog').showModal();

  document.querySelectorAll('.bh-live-search').forEach((root) => {
    const input = root.querySelector('input[type="search"]');
    const panel = root.querySelector('.bh-live-results');
    let timer, controller;
    const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      controller?.abort();
      const query = input.value.trim();
      close();
      if (query.length < 2) return;
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const url = new URL(root.dataset.predictiveUrl, location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('type', 'product');
          url.searchParams.set('section_id', 'bubima-predictive-search');
          const response = await fetch(url, { signal:controller.signal });
          if (!response.ok) return;
          const html = await response.text();
          if (input.value.trim() !== query) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const results = doc.querySelector('[data-bubima-predictive]');
          if (!results) return;
          panel.replaceChildren(...results.childNodes);
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        } catch (error) { if (error.name !== 'AbortError') close(); }
      }, 250);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' && !panel.hidden) { event.preventDefault(); panel.querySelector('a')?.focus(); }
      if (event.key === 'Escape') close();
    });
    panel.addEventListener('keydown', (event) => { if (event.key === 'Escape') { close(); input.focus(); } });
    document.addEventListener('click', (event) => { if (!root.contains(event.target)) close(); });
    root.addEventListener('focusout', () => { setTimeout(() => { if (!root.contains(document.activeElement)) close(); }, 0); });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
